import { clearOnboardingCache } from './onboardingCache';

/**
 * Centralized logout handler that clears all caches and performs cleanup
 */
export function handleLogout(clerkSignOut: () => Promise<void>) {
  return async () => {
    try {
      console.log('🔒 Logout: Clearing onboarding cache');
      clearOnboardingCache();
      
      console.log('🔒 Logout: Signing out from Clerk');
      await clerkSignOut();
      
      console.log('🔒 Logout: Redirecting to homepage');
      window.location.href = '/';
    } catch (error) {
      console.error('🔒 Logout failed:', error);
      // Still try to redirect even if logout fails
      window.location.href = '/';
    }
  };
}

/**
 * Clear caches when organization changes occur
 */
export function handleOrganizationChange() {
  console.log('🔒 Organization change: Clearing onboarding cache');
  clearOnboardingCache();
}
